import * as React from 'react'
import { Link } from 'react-router-dom'
import UIMessages from '../../../utils/ui-messages'
import HorizontalSelectorItemCustom from './HorizontalSelectorItemCustom'
import TabBar from '../../ui/entity/EntityTabBar'
import TabBarItem from '../../ui/entity/EntityTabBarItem'

export interface IRiderProfileEditSelectorProps {
  pathname: string
  riderId: string
}

const RiderProfileEditStepSelector = ({ pathname, riderId }: IRiderProfileEditSelectorProps) => {
  return (
    <div className='col-12 tab-selector'>
      <div className='flex bb-light-grey4'>
        <TabBar>
          <TabBarItem active={/\/profile/.test(pathname)}>
            <Link to={`/riders/${riderId}/edit/profile`}>{UIMessages.common.profile}</Link>
          </TabBarItem>
          {/* <TabBarItem active={/\/recurringTrips/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/recurringTrips`}>{UIMessages.rider.recurringTrips.plannedTrips}</Link>
          </TabBarItem> */}
          <TabBarItem active={/\/location/.test(pathname)}>
            <Link to={`/riders/${riderId}/edit/location`}>{UIMessages.rider.locations}</Link>
          </TabBarItem>
          <TabBarItem active={/\/membership/.test(pathname)}>
            <Link to={`/riders/${riderId}/edit/membership`}>{UIMessages.common.membership}</Link>
          </TabBarItem>
          <TabBarItem active={/\/wallet/.test(pathname)}>
            <Link to={`/riders/${riderId}/edit/wallet`}>{UIMessages.common.wallet}</Link>
          </TabBarItem>
          {/* <TabBarItem active={/\/promotions/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/promotions`}>{UIMessages.common.promotions}</Link>
          </TabBarItem> */}
        </TabBar>
        <div style={{ flex: 4 }}>&nbsp;</div>

        <div className='absolute z1 left-0 right-0 bottom-0 bb-light-grey4' />
      </div>
    </div>
  )
}

export default RiderProfileEditStepSelector



// WEBPACK FOOTER //
// ./src/components/riders/editrider/RiderProfileEditStepSelector.tsx